module.exports = __webpack_public_path__ + "img/e42d6e4.jpg";